import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiBarChart3, FiInfo, FiCalendar } = FiIcons;

const Navigation = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
                  <FiUsers className="w-5 h-5 text-white" />
                </div>
                <span className="text-xl font-bold text-gray-900">Free Attendance Tracker</span>
              </div>
            </Link>
          </div>
          
          <div className="flex items-center space-x-4">
            <Link
              to="/tracker"
              className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center ${
                isActive('/') || isActive('/tracker')
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              <SafeIcon icon={FiCalendar} className="w-4 h-4 mr-2" />
              Tracker
            </Link>
            <Link
              to="/analytics"
              className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center ${
                isActive('/analytics')
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              <SafeIcon icon={FiBarChart3} className="w-4 h-4 mr-2" />
              Analytics
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg font-medium transition-colors flex items-center ${
                isActive('/about')
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
              }`}
            >
              <SafeIcon icon={FiInfo} className="w-4 h-4 mr-2" />
              About
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;